import React, { useState, useEffect } from "react";
import { Button, Card, Col, Container, Row } from "reactstrap";
import LandingAuth from "../../../AuthenticationInner/LandingAuth";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { resetLoginFlag } from "../../../../slices/thunks";
import PackageCard from "../Component/PackageCard";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PackageServices from "../../../../services/PackageServices/PackageServices";
import { resetBooking } from "../../../../slices/Package/bookingSlice";
// import ParticlesAuth from "src/pages/AuthenticationInner/ParticlesAuth";
import { Triangle } from "react-loader-spinner";

const Package = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Selectors for redux state
  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));

  const { user, error, loading, errorMsg } = useSelector(loginpageData);

  const [packageData, setPackageData] = useState([]);
  const [drivingData, setDrivingData] = useState([]);
  console.log("drivingData", drivingData);

  const drivingTestData = async () => {
    try {
      const fetchedDrivingData = await PackageServices.get();
      const filteredData = fetchedDrivingData.data?.filter(
        (packageItem) => packageItem.package_type === "DRVING-TEST"
      );
      console.log("filteredDataaaa", filteredData);
      setDrivingData(
        filteredData.length > 0 ? filteredData : fetchedDrivingData.data
      );
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch package data from the API
  const fetchData = async () => {
    try {
      const fetchedData = await PackageServices.get();
      const filteredData = fetchedData.data?.filter(
        (packageItem) => packageItem.package_type !== "DRVING-TEST"
      );
      setPackageData(filteredData.length > 0 ? filteredData : fetchedData.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
    drivingTestData();

    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }

    if (user) {
      navigate("/payment");
    }
  }, [dispatch, errorMsg, user, navigate]);

  useEffect(() => {
    document.title = "Cosmos Driving | Packages and Offers";
  }, []); // Use a separate useEffect for setting document title.

  const handleBookNew = () => {
    dispatch(resetBooking()); // Dispatch an action to reset the booking form state
    navigate(`/book-driving-lesson/${drivingData?.[0]?.id}`);
  };

  return (
    <React.Fragment>
      <LandingAuth>
        <Container className="mt-5 pt-5">
          <Row className="d-flex justify-content-center mt-3">
            <Col lg={12} className="text-center mb-3">
              <h6 className="fs-14 fw-600">Please Select</h6>
              <h6 className="fs-24 fw-bold">Packages & Offers</h6>
            </Col>
            <Col lg={12}>
              {/* Carousel for small screens */}
              {loading ? (
                <div className="text-center">
                  <Triangle
                    visible={true}
                    height="60"
                    width="60"
                    color="#5B71B9"
                    ariaLabel="triangle-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              ) : (
                <>
                  <div className="d-block d-md-none">
                    <Carousel
                      showThumbs={false}
                      showStatus={false}
                      infiniteLoop
                      useKeyboardArrows
                      autoPlay
                      interval={5000}
                    >
                      {packageData?.map((packageItem, key) => (
                        <Col lg={3} md={6} sm={12} key={key}>
                          <PackageCard
                            rate={packageItem.price}
                            type={packageItem.name}
                            CarType={
                              packageItem.details.find(
                                (detail) => detail.title === "Car Type"
                              )?.value || ""
                            }
                            FreePickup={packageItem.pickup_drop_text}
                            Time={
                              packageItem.details.find((detail) =>
                                detail.title.includes("Days")
                              )?.value || ""
                            }
                            per={packageItem.package_type}
                            id={packageItem.id}
                            planButtonClassname={
                              packageItem.planButtonClassname || ""
                            }
                            is_popular={packageItem.is_popular === 1}
                            promotion_text={packageItem.promotion_text || ""}
                            showButton={true}
                            show_promotion={packageItem.show_promotion === 1}
                            details={packageItem.details}
                            show={true}
                          />
                        </Col>
                      ))}
                    </Carousel>
                  </div>
                  {/* Grid for larger screens */}
                  <div className="d-none d-md-block">
                    <Row className="d-flex justify-content-center">
                      {packageData?.map((packageItem, key) => (
                        <Col lg={3} md={6} sm={12} key={key}>
                          <PackageCard
                            rate={packageItem.price}
                            type={packageItem.name}
                            CarType={
                              packageItem.details.find(
                                (detail) => detail.title === "Car Type"
                              )?.value || ""
                            }
                            FreePickup={packageItem.pickup_drop_text}
                            Time={
                              packageItem.details.find((detail) =>
                                detail.title.includes("Days")
                              )?.value || ""
                            }
                            per={packageItem.package_type}
                            id={packageItem.id}
                            planButtonClassname={
                              packageItem.planButtonClassname || ""
                            }
                            is_popular={packageItem.is_popular === 1}
                            promotion_text={packageItem.promotion_text || ""}
                            showButton={true}
                            show_promotion={packageItem.show_promotion === 1}
                            details={packageItem.details}
                            show={true}
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                </>
              )}
            </Col>

            <Col lg={9} xs={12} className="mb-5">
              <Card className="p-4 mb-4" style={{ borderRadius: "15px" }}>
                <Row>
                  <Col lg={7} xs={12}>
                    <h6 className="fw-bold fs-16">
                      Need car for driving test?
                    </h6>
                    <p>
                      We've secured the perfect car for your driving test. To
                      ensure a seamless experience, we kindly invite you to get
                      in touch with us at your earliest convenience to secure
                      your booking. We look forward to assisting you on your
                      journey to obtaining your driver's license.
                    </p>
                    <Button
                      outline
                      color="primary"
                      // onClick={() => navigate(`/book-driving-lesson/${drivingData?.[0]?.id}`)}
                      onClick={handleBookNew}
                    >
                      Book Now
                    </Button>
                  </Col>

                  <Col
                    lg={5}
                    xs={12}
                    className="d-flex justify-content-lg-end justify-content-center align-content-end mt-2 mt-lg-0"
                  >
                    {drivingData?.map((packageItem, key) =>
                      packageItem?.package_type === "DRIVING-TEST" ? (
                        <Col lg={10} md={6} sm={12} key={key}>
                          <PackageCard
                            rate={packageItem.price}
                            type={packageItem.name}
                            CarType={
                              packageItem.details.find(
                                (detail) => detail.title === "Car Type"
                              )?.value || ""
                            }
                            FreePickup={packageItem.pickup_drop_text}
                            Time={
                              packageItem.details.find((detail) =>
                                detail.title.includes("Days")
                              )?.value || ""
                            }
                            id={packageItem.id}
                            show_promotion={packageItem.show_promotion === 1}
                            details={packageItem.details}
                          />
                        </Col>
                      ) : null
                    )}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </LandingAuth>
    </React.Fragment>
  );
};

export default Package;
